import React, { useEffect, useState } from 'react'
import Workflow from './Workflow'
import { timelineService } from '../../services/timelineService'
import { useAuthContext } from '../../hooks/useAuthContext'
import { useNavigate } from 'react-router-dom'

const considerDelegation = (pdData, delegationTracker) => {
  // clone input data so we NEVER mutate the original
  let finalPdData = pdData.map((it) => ({ ...it }))

  delegationTracker.forEach((delegation, index) => {
    const delegatedTask = finalPdData.find((it) => it.id == delegation.process_id)

    if (delegatedTask?.from_process_ids == null) {
      // keep delegation as first
      const delegationNode = {
        ...delegation,
        created_at: delegatedTask.created_at,
        modified_at: delegation.delegated_at,
        created_by: delegation.delegated_by,
        modified_by: delegation.delegated_to,
        from_process_ids: [],
        to_process_ids: [delegatedTask.id],
        id: delegatedTask.id + '_delegated_' + (index + 1),
        activity_template_name: delegatedTask.activity_template_name,
        status: 'delegated',
        assignee: delegation.delegated_by,
      }

      // back link delegated task with delegation node
      delegatedTask.from_process_ids = [delegationNode.id]
      delegatedTask.created_at = delegationNode.delegated_at

      // add delegation node
      finalPdData.push(delegationNode)
    } else {
      const previousNode = finalPdData.find((it) => it.id == delegatedTask?.from_process_ids[0])
      const delegationNode = {
        ...delegation,
        created_at: delegatedTask.created_at,
        modified_at: delegation.delegated_at,
        created_by: delegation.delegated_by,
        modified_by: delegation.delegated_to,
        from_process_ids: delegatedTask.from_process_ids,
        to_process_ids: [delegatedTask.id],
        id: delegatedTask.id + '_delegated_' + (index + 1),
        activity_template_name: delegatedTask.activity_template_name,
        status: 'delegated',
        assignee: delegation.delegated_by,
      }

      // update previous node
      previousNode.to_process_ids = [delegationNode.id]
      previousNode.modified_at = delegationNode.delegated_at

      // update original task
      delegatedTask.from_process_ids = [delegationNode.id]
      delegatedTask.created_at = delegationNode.delegated_at
      delegatedTask.assignee = delegation.delegated_to

      // add delegation node
      finalPdData.push(delegationNode)
    }
  })

  return finalPdData
}

/* 

const pdData = [
  {
    assignee: "Vidya MP",
    activity_template_name: "Initiate PTP",
    activity_type: "data-entry",
    id: "19294",
    data: '{"f_11565": "Suvam ", "f_11566": "Chakrvarty"}',
    created_by: 207,
    modified_by: 207,
    created_at: "2025-12-01T05:43:54.135Z",
    modified_at: "2025-12-01T05:44:40.922Z",
    process_reference_num: 1002,
    process_template_id: 109,
    activity_template_id: 728,
    version: 1,
    is_draft: false,
    review_data: "{}",
    status: "closed",
    from_route_template_id: null,
    to_route_template_id: 1321,
    review_comments_data: "{}",
    overall_comments: "Testing...",
    from_process_id: null,
    to_process_id: null,
    selectable_tables_data: "{}",
    lrp_review_details: null,
    outbound_server_action_status: [],
    cr_changes: [],
    from_process_ids: null,
    to_process_ids: [19295],
    is_incomplete: false,
  }
]

const delegationTracker = [
  {
    id: 1,
    delegated_at: "2025-12-02T03:48:07.134Z",
    process_id: "19320",
    comments: "Testing",
    delegated_by: "Vidya MP",
    delegated_to: "Nitish Kumar",
  },
]

*/
const ParallelRouteTimeline = ({ processReferenceNum, processTemplateId, openProcessData }) => {
  const navigate = useNavigate()
  const { user } = useAuthContext()
  const [pdDataFinal, setPdDataFinal] = useState([])
  const [docMap, setDocMap] = useState({})

  // fetch data from server
  useEffect(() => {
    ;(async () => {
      const { pdData, delegationTrackerData, docMap } = await timelineService.getTimelineData(
        user,
        processReferenceNum,
        processTemplateId
      )

      const finalPdData = considerDelegation(pdData, delegationTrackerData)
      setPdDataFinal(finalPdData)
      setDocMap(docMap)
    })()
  }, [user, processReferenceNum, processTemplateId])

  const workOnTask = (pd) => {
    navigate(`/process-data/${pd.id}/${pd.activity_template_id}`)
  }

  return (
    <Workflow
      nodes={pdDataFinal}
      openProcessData={openProcessData}
      openTask={workOnTask}
      docMap={docMap}
    />
  )
}

export default ParallelRouteTimeline
